(function () {
    'use strict';

    angular.module('app').controller('SeriesController', SeriesController);

    SeriesController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$timeout',
        '$location',
        '$filter',
        'blockUI',
        '$uibModal',
        'ExportService',
        'BusinessService',
        'CouponsService',
        'LoyaltyService',
        'MessageService',
        'SelectService',
        'SendMessageService',
        'SettingsService',
        'NotifyService',
        'LANGS',
        'ReceiptService',
        '$sce'
    ];

    function SeriesController(
        $rootScope,
        $scope,
        $routeParams,
        $timeout,
        $location,
        $filter,
        blockUI,
        $uibModal,
        ExportService,
        BusinessService,
        CouponsService,
        LoyaltyService,
        MessageService,
        SelectService,
        SendMessageService,
        SettingsService,
        NotifyService,
        LANGS,
        ReceiptService,
        $sce
    ) {

        $scope.isParimatch = appConfig.platformParams.main_site.en === 'pmclub.bet';

        $scope.model = {};
        $scope.error = {};
        $scope.modals = {};
        $scope.state = {
            details: {
                tab: 'coupons'
            }
        };

        var today = {
            date: moment().endOf('day').utc().toDate(),
            time: moment().endOf('day').utc().toDate()
        };

        $scope.selectedCouponsUserIds = {};

        $scope.params = {
            filterDates: {
                startDate: {
                    date: moment().subtract(1, 'month').utc().toDate(),
                    time: moment().startOf('day').utc().toDate()
                },
                coupon_emission_dt_from: {},
                coupon_emission_dt_to: angular.copy(today),
                coupon_taken_by_customer_dt_from: {},
                coupon_taken_by_customer_dt_to: angular.copy(today),
                coupon_redeem_dt_from: {},
                coupon_redeem_dt_to: angular.copy(today),
                enableCouponEmissionFilter: false,
                enableCouponTakenByCustomerFilter: false,
                enableCouponRedeemFilter: false
            },
            batches: {
                page: 1,
                count: 20,
                only_active: true,
                batch_type: 'all',
                code: '',
                title: '',
                date_from: moment().subtract(12, 'month').utc().toDate(),
                date_to: moment().endOf('day').utc().toDate(),
                time_from: moment().startOf('day').utc().toDate(),
                time_to: moment().endOf('day').utc().toDate(),
            },
            coupons: {
                page: 1,
                count: 50,
                sort_field: 'emission_dt',
                sort_order: 'desc'
            },
            aliases: {
                code: '',
                only_active: true,
                count: 20,
                page: 1,
                date_from: moment().subtract(12, 'month').utc().toDate(),
                date_to: moment().endOf('day').utc().toDate(),
                time_from: moment().startOf('day').utc().toDate(),
                time_to: moment().endOf('day').utc().toDate(),
                sort_field: 'created',
                sort_order: 'desc'
            },
            external_codes: {
                page: 1,
                count: 50
            }
        };

        $scope.data = {
            isFilePreparing: false,
            dateOptions: {
                minDate: new Date()
            },
            batchImage: {
                src: '',
                cropped: '',
                new: false
            },
            summary: {},
            summaryCoupons: {},
            summaryExternalCodes: {},
            couponsGeneration: {
                status: false,
                progress: 0
            },
            externalCodesImport: {
                status: false,
                progress: 0,
                results: {}
            },
            series_types: [
                {id: 'all', title: 'All coupon series'},
                {id: 'check-modifier', title: 'TEXT_COUPON_BATCH_COUPON_TYPE_VALUE_CHECK_MODIFIER'},
                {id: 'certificate', title: 'TEXT_COUPON_BATCH_COUPON_TYPE_VALUE_CERTIFICATE'},
                {id: 'external', title: 'TEXT_COUPON_BATCH_COUPON_TYPE_VALUE_EXTERNAL'},
                {id: 'cross-business', title: 'TEXT_COUPON_BATCH_COUPON_TYPE_VALUE_CROSS'}
            ],
            coupon_status: [
                {id: 'all', title: 'All status coupon'},
                {id: 'open', title: 'Open status coupon'},
                {id: 'redeemed', title: 'Redeemed status coupon'},
                {id: 'cancelled', title: 'Cancelled status coupon'}
            ],
            coupon_deleted: [
                {id: 'all', title: 'All status coupon'},
                {id: 'yes', title: 'Coupon deleted yes'},
                {id: 'no', title: 'Coupon deleted no'}
            ],
            coupon_expired: [
                {id: 'all', title: 'All status coupon'},
                {id: 'yes', title: 'Coupon expired yes'},
                {id: 'no', title: 'Coupon expired no'}
            ],
            coupon_added_to_wallet: [
                {id: 'all', title: 'All status coupon'},
                {id: 'yes', title: 'Coupon added to wallet yes'},
                {id: 'no', title: 'Coupon added to wallet no'}
            ],
            pagerLengths: [10, 20, 50, 100, 200]
        };

        $scope.table_cols = [
            {
                visible: true,
                data: [
                    {value: 'code', text: 'code', visible: true},
                    {value: 'external_code', text: 'TEXT_COUPON_BATCH_EXTERNAL_CODE', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'title', text: 'TEXT_COUPON_BATCH_NAME', visible: true},
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'alias', text: 'alias_code', visible: true},
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emission_dt', text: 'emission_dt', visible: true},
                    {value: 'status', text: 'Status', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emission_type', text: 'emission_type', visible: true, not_sortable: true},
                    {value: 'emission_source', text: 'emission_source', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'taken_by_customer_dt', text: 'Coupon taken by customer date', visible: true},
                    {value: 'redeem_dt', text: 'redeem_dt', visible: true},
                    {value: 'cancel_dt', text: 'cancel_dt', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'redeem_type', text: 'redeem_type', visible: true, not_sortable: true},
                    {value: 'redeem_agent', text: 'redeem_agent', visible: true, not_sortable: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'user_id', text: 'Customer', visible: true, not_sortable: false},
                    {value: 'email', text: 'Customer email', visible: true},
                    {value: 'deleted_by_customer', text: 'deleted_by_customer', visible: true, not_sortable: false}
                ]
            }
        ];

        $scope.table_aliases_cols = [
            {
                visible: true,
                data: [
                    {value: 'code', text: 'ALIAS_CODE', visible: true},
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'active', text: 'Status', visible: true, not_sortable: true},
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'created', text: 'Created', visible: true},
                ]
            },
            {
                visible: false,
                data: [
                    {value: 'batch_code', text: 'TEXT_RULE_COUPON_BATCH_CODE', visible: false},
                    {value: 'batch_title', text: 'TEXT_COUPON_BATCH_NAME', visible: false},
                ]
            },
        ];

        var block_batch_edit = blockUI.instances.get('coupon_batch_edit'),
            block_batches_list = blockUI.instances.get('batches_list'),
            block_batch_coupon_list = blockUI.instances.get('batch_coupon_list'),
            block_batch_aliases_list = blockUI.instances.get('batch_aliases_list'),
            block_batch_external_codes_list = blockUI.instances.get('batch_external_codes_list');

        $scope.isPageMode = isPageMode;

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.getLoyaltyRules = getLoyaltyRules;
        $scope.getAccountsList = getAccountsList;
        $scope.getCurrenciesList = getCurrenciesList;

        $scope.multiLang = MultilanguageHelper();

        $scope.onChangeLanguage = onChangeLanguage;

        $scope.getPages = getTotalPaginatedPages;

        $scope.publicDescriptionEditorField = true;

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        $scope.decodeHtml = function (html) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = html;
            var decodedHtml = textArea.value;
            return decodedHtml.replace(/<a(?![^>]*\btarget\b)([^>]*)>/g, '<a target="_blank"$1>');
        }

        initController();

        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('batch_id')) ? 'edit' : 'show';
            } else if (isRouteMode('details')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('batch_id')) ? 'details' : 'show';
            } else if (isRouteMode('duplicate')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('batch_id')) ? 'duplicate' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }
            if ($scope._pageMode == 'details') _doDetails();
        }

        function initmultiLang() {
            $scope.multiLang.initLangs(LANGS, $rootScope.LANG);
        }

        function initController() {
            SettingsService.GetPlatformParams(function (success, response) {

                if (success) {
                    $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;
                }
                initmultiLang();
                initPageMode();
            });
        }

        /**
         * Event rice when user change current page (next or prev) or change items count on page
         */
        $scope.onChangeCouponsPager = function () {
            console.log('TablePager onPagerChange', $scope.params.coupons);
            getCoupons();
        };

        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();
            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                        );
                    }

                    $scope.$apply(function () {
                        $scope.data.batchImage.new = true;
                        $scope.data.batchImage.src = resizedImageDataUrl
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('couponBatchImage'));
            file.on('change', $scope.handleFileSelect);
        };

        $scope.setDefaultBatchImage = function () {
            $scope.data.batchImage.new = false;
            $scope.data.batchImage.cropped = '';
            $scope.data.batchImage.src = '';
        }

        $scope.cropBatchImage = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.batchImage);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.batchImage = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        $scope.onGetBatches = function () {
            getCouponsBatches(function (success) {
            });
        }

        $scope.getAllCouponsBatches = function (callback) {

            $scope.data.couponAllBatchesList = [
                {
                    title: 'Loading...',
                    code: 'fake_loading',
                    fake: true
                }
            ];

            var params = {
                page: 1,
                count: 500,
                only_active: false
            };

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id)
                params.loyalty = $scope.data.currentLoyalty.id;

            CouponsService.Batches(params, function (success, response) {
                if (success) {
                    $scope.data.couponAllBatchesList = response.data;
                    callback(true);
                } else {
                    $scope.data.couponAllBatchesList = [
                        {
                            title: 'No data set',
                            code: 'fake_data',
                            fake: true
                        }
                    ];
                    callback(false);
                }
            });
        }


        function getCouponsBatches(callback) {
            block_batches_list.start();
            var params = {};

            params = angular.copy($scope.params.batches);

            if (params.batch_type == 'all') {
                delete params.batch_type;
            }

            params.created_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            }).toISOString();
            delete params.time_from;
            delete params.date_from;

            params.created_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            }).toISOString();
            delete params.time_to;
            delete params.date_to;

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id)
                params.loyalty_id = $scope.data.currentLoyalty.id;

            CouponsService.Batches(params, function (success, response) {

                if (success) {
                    $scope.data.couponBatchesList = response.data;
                    $scope.data.summary = response.summary;
                    callback(true);
                } else {
                    callback(false);
                }

                block_batches_list.stop();
            });
        }

        function getCouponsBatch(batch_id, callback) {
            block_batch_edit.start();
            CouponsService.Batch(batch_id, function (success, response) {
                if (success) {
                    $scope.model.batch = angular.copy(response);
                    callback(true, response);
                } else {
                    $location.path('/series');
                    callback(false, response);
                }

                block_batch_edit.stop();
            });
        }

        function getCoupons() {
            block_batch_coupon_list.start();

            var params = angular.copy($scope.params.coupons);
            var filterDates = angular.copy($scope.params.filterDates);

            if ($scope.model.batch.loyalty_id) {
                params.loyalty_id = $scope.model.batch.loyalty_id;
            }
            if ($scope.model.batch.id) {
                params.batch_id = $scope.model.batch.id;
            }

            if ($scope.params.filterDates.enableCouponEmissionFilter) {
                params.coupon_emission_dt_from = transformDateForRequest(filterDates.coupon_emission_dt_from);
                params.coupon_emission_dt_to = transformDateForRequest(filterDates.coupon_emission_dt_to);
            }

            if ($scope.params.filterDates.enableCouponTakenByCustomerFilter) {
                params.coupon_taken_by_customer_dt_from = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_from);
                params.coupon_taken_by_customer_dt_to = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_to);
            }

            if ($scope.params.filterDates.enableCouponRedeemFilter) {
                params.coupon_redeem_dt_from = transformDateForRequest(filterDates.coupon_redeem_dt_from);
                params.coupon_redeem_dt_to = transformDateForRequest(filterDates.coupon_redeem_dt_to);
            }

            CouponsService.Coupons(params, function (success, response) {
                if (success) {
                    $scope.data.couponsList = response.data;
                    $scope.data.summaryCoupons = response.summary;

                    $timeout(function () {
                        block_batch_coupon_list.stop();
                    }, 1000);
                }
            });
        }

        function transformDateForRequest(dateTimeStruct) {
            return moment(dateTimeStruct.date).set({
                hour: moment(dateTimeStruct.time).get('hour'),
                minute: moment(dateTimeStruct.time).get('minute'),
                second: moment(dateTimeStruct.time).get('second')
            });
        }

        function getExternalCodes(callback) {
            var params = {
                page: $scope.params.external_codes.page,
                count: $scope.params.external_codes.count
            };

            block_batch_external_codes_list.start();

            CouponsService.ExternalCodes($scope.model.batch.id, params, function (success, response) {
                if (success) {
                    $scope.data.externalCodesList = response.data;
                    $scope.data.summaryExternalCodes = response.summary;

                    block_batch_external_codes_list.stop();
                }
                callback(success, response);
            });
        }

        $scope.onSeriesExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;

            var params = angular.copy({
                batch_id: $scope.model.batch.id,
                loyalty_id: $scope.model.batch.loyalty_id
            });
            params = Object.assign(params, $scope.params.coupons);

            var filterDates = angular.copy($scope.params.filterDates);

            if ($scope.params.filterDates.enableCouponEmissionFilter) {
                params.coupon_emission_dt_from = transformDateForRequest(filterDates.coupon_emission_dt_from);
                params.coupon_emission_dt_to = transformDateForRequest(filterDates.coupon_emission_dt_to);
            }

            if ($scope.params.filterDates.enableCouponTakenByCustomerFilter) {
                params.coupon_taken_by_customer_dt_from = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_from);
                params.coupon_taken_by_customer_dt_to = transformDateForRequest(filterDates.coupon_taken_by_customer_dt_to);
            }

            if ($scope.params.filterDates.enableCouponRedeemFilter) {
                params.coupon_redeem_dt_from = transformDateForRequest(filterDates.coupon_redeem_dt_from);
                params.coupon_redeem_dt_to = transformDateForRequest(filterDates.coupon_redeem_dt_to);
            }

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_series-coupons_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                var export_struct = [];

                for (var i in $scope.table_cols) {

                    if ($scope.table_cols[i].visible) {
                        for (var k in $scope.table_cols[i].data) {
                            var text = $scope.table_cols[i].data[k].text,
                                value = $scope.table_cols[i].data[k].value;
                            export_struct.push({
                                text: $filter('translate')(text) || text,
                                value: value
                            });
                        }
                    }
                }

                export_struct.push({
                    text: $filter('translate')('Text_Link'),
                    value: 'coupon_text_link'
                });

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;

                        switch (export_struct[k].value) {
                            case 'coupon_text_link':
                                var url_code = JSON.parse(JSON.stringify(tl[i]['code']));
                                b = 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] +
                                    '/coupon/show/{0}?lang={1}'.format(url_code, $rootScope.LANG);
                                break;
                            case 'code':
                                var code = tl[i]['code'];
                                b = $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' + $filter('limitTo')(code, 4, 8);
                                break;
                            case 'external_code':
                                b = tl[i]['external_code'] || '';
                                break;
                            case 'user_external_id':
                                b = tl[i]['external_id'] || '';
                                break;
                            case 'user_id':
                                b = '';
                                if (!!tl[i]['customer']) {
                                    b = (tl[i]['customer']['phone'] || '') + ' - ' + (tl[i]['customer']['name'] || '');
                                }

                                break;
                            case 'alias':
                                var code = '';
                                if (
                                    tl[i]['batch'] &&
                                    tl[i]['batch']['alias'] &&
                                    tl[i]['batch']['alias']['code']
                                ) {
                                    code = tl[i]['batch']['alias']['code'];
                                }
                                b = code ? $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' + $filter('limitTo')(code, 4, 8) : '';
                                break;
                            case 'emission_dt':
                                b = $filter('date')(tl[i]['emission_dt'], 'medium', '+0');
                                break;
                            case 'redeem_dt':
                                b = $filter('date')(tl[i]['redeem_dt'], 'medium', '+0');
                                break;
                            case 'cancel_dt':
                                b = $filter('date')(tl[i]['cancel_dt'], 'medium', '+0');
                                break;

                            case 'emission_type':
                                b = '';
                                if (!!tl[i]['emitter_batch']) {
                                    b = $filter('translate')('TEXT_EMMITED_BY_CROSS_BUSINESS');
                                }
                                if (!!tl[i]['emission_transaction']) {
                                    b = $filter('translate')('TEXT_EMMITED_BY_RULE');
                                }
                                if (!!tl[i]['share']) {
                                    b = $filter('translate')('TEXT_EMMITED_BY_SHARE');
                                }

                                break;

                            case 'emission_source':
                                b = '';
                                if (!!tl[i]['emitter_batch']) {
                                    b = tl[i]['emitter_batch']['loyalty_title'];
                                }
                                if (!!tl[i]['emission_transaction']) {
                                    b = tl[i]['emission_transaction']['terminal_title'];
                                }
                                if (!!tl[i]['share']) {
                                    b = tl[i]['share']['user_phone'];
                                }

                                break;

                            case 'redeem_type':
                                b = '';
                                if (!!tl[i]['redeem_transaction']) {
                                    b = $filter('translate')('TEXT_REDEEMED_BY_REGISTER');
                                }
                                break;

                            case 'redeem_agent':
                                b = '';
                                if (!!tl[i]['redeem_transaction']) {
                                    b = tl[i]['redeem_transaction']['terminal_title'];
                                }
                                break;

                            case 'deleted_by_customer':
                                if (tl[i]['cancel_dt'] == 1) {
                                    b = $filter('translate')('deleted_by_customer');
                                } else {
                                    b = '';
                                }

                                break;

                            case 'email':
                                b = '';
                                if (!!tl[i]['customer']) {
                                    b = tl[i]['customer']['email'] || '';
                                }
                                break;

                            case 'status' :
                                b = $filter('translate')(tl[i]['status']) || '';
                                break;

                            // case 'emission_type':
                            //     b = $filter('date')(tl[i]['cancel_dt'], 'medium', '+0');
                            //     break;

                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                        }
                        el[a] = b || '';
                    }

                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }
                return void (0);
            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.data.summaryCoupons.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getCoupons(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.data.summaryCoupons.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;
                tl.forEach(function (item) {
                    item.id = item.user_id;
                });

                generateFile();
            }

            function getCoupons(params) {
                return new Promise(function (resolve) {
                    CouponsService.Coupons(params, function (success, response) {
                        resolve(response);
                    });
                });
            }

            exportRequest();
        };

        $scope.onExternalCodeDelete = function (c) {
            var post_data = [c];

            CouponsService.ExternalCodesDelete($scope.model.batch.id, post_data, function (success, response) {
                if (success)
                    getExternalCodes(function (success, response) {
                    });
            });
        };

        function getCoupon(code, callback) {
            CouponsService.GetCoupon(code, function (success, response) {
                if (success)
                    callback(true, response);
                else
                    callback(false, response);
            });
        }

        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0)
                BusinessService.CurrencyList(null, function (success, response) {
                    if (success)
                        $scope.data.currenciesList = response;
                    if ($scope.data.currenciesList.indexOf('EUR') == -1)
                        $scope.data.currenciesList.push('EUR');

                    if ($scope.data.currenciesList.indexOf('USD') == -1)
                        $scope.data.currenciesList.push('USD');
                });
        }

        function getLoyaltyRules() {
            var id = $scope.data.currentLoyalty.id;

            LoyaltyService.LoyaltyRules(id, function (success, response) {
                if (success) {
                    $scope.data.currentLoyaltyRule = null;
                    $scope.data.loyaltyRules = [];
                    for (var i in response)
                        if (response[i].automatic === 2) { // automatic === 2 means that loyalty rule applicable for coupons
                            $scope.data.loyaltyRules.push(response[i]);
                        }
                }
            });
        }

        function getAccountsList() {
            BusinessService.SpecialAccounts(function (success, response) {
                if (success) {
                    $scope.data.currentSpecialAccount = null;
                    $scope.data.specialAccountsList = [];

                    for (var i in response)
                        if (response[i].active === 1)
                            $scope.data.specialAccountsList.push(response[i]);

                    if ($scope.data.specialAccountsList.length > 0) {
                        if (!$scope.model.batch.special_account_id)
                            $scope.model.batch.special_account_id = $scope.data.specialAccountsList[0].id;

                        if (!$scope.model.batch.recommendation_fee_special_account_id)
                            $scope.model.batch.recommendation_fee_special_account_id = $scope.data.specialAccountsList[0].id;

                        if (!$scope.model.batch.customers_price_special_account_id)
                            $scope.model.batch.customers_price_special_account_id = $scope.data.specialAccountsList[0].id;
                    }

                }
            });
        }

        function handleBatchData() {
            var cf = {
                coupon_expire_type: 'none',
                coupon_expire_value: 1,
                coupon_expire_date: moment().add(1, 'month').utc().toDate(),
                bonuses_currency: $rootScope.ENV.business.currency,
                charge_amount: 0,
                promotional_bonuses_expire_value: 1,
                promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                recommendation_fee_bonuses_currency: $rootScope.ENV.business.currency,
                recommendation_fee_amount: 0,
                recommendation_fee_type: 'none',
                promotional_bonuses_expire_type: 'date',
                recommendation_fee_promotional_bonuses_expire_type: 'date',
                recommendation_fee_promotional_bonuses_expire_value: 1,
                recommendation_fee_promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                exchange_coupon_redeem_fee: 0,
                anonymous_owned_data_access_allowed: 1,
                external_codes_list_import: [],
                exchange_coupon_redeem_fee_allowed: false,
                customers_price_amount_free: true,
                customers_price_type: 'bonuses',
                customers_price_currency: $rootScope.ENV.business.currency
            };

            for (var i in cf)
                if (!$scope.model.batch[i])
                    $scope.model.batch[i] = cf[i];

            if ($scope.model.batch.emission_quantity_limit === 0)
                $scope.model.batch.emission_quantity_limit_unlimited = true;

            if ($scope.model.batch.emission_per_customer_limit === 0)
                $scope.model.batch.emission_per_customer_limit_unlimited = true;

            if ($scope.model.batch.exchange_coupon_redeem_fee > 0)
                $scope.model.batch.exchange_coupon_redeem_fee_allowed = true;

            if ($scope.model.batch.customers_price_amount > 0)
                $scope.model.batch.customers_price_amount_free = false;
        }

        function generateCoupons(batch_id, quantity, callback) {

            var chunk = 50,
                total = quantity,
                iterations = Math.ceil(quantity / chunk),
                step = 1,
                params = {};

            if (iterations < 1)
                iterations = 1;

            $scope.data.couponsGeneration.status = true;
            $scope.data.couponsGeneration.progress = 0;

            // $scope.data.couponsList = [];

            function handleResult(success, result) {
                if ($scope.data.couponsGeneration.status) {
                    if (success) {
                        // $scope.data.couponsList = $scope.data.couponsList.concat(result.data);
                        $scope.data.couponsGeneration.progress += 100 / iterations;

                        ++step;
                        total -= chunk;
                        if (step == iterations) {
                            params.count = total;
                            CouponsService.GenerateCoupons(batch_id, params, handleResult);
                        } else if (step < iterations) {
                            params.count = chunk;
                            CouponsService.GenerateCoupons(batch_id, params, handleResult);
                        } else if (step > iterations) {
                            $scope.data.couponsGeneration.status = false;
                            $scope.data.couponsGeneration.progress = 100;
                            callback(success, result);
                        }
                    }
                } else {
                    $scope.data.couponsGeneration.status = false;
                }
            }

            if (iterations == 1) {
                params.count = total;
                CouponsService.GenerateCoupons(batch_id, params, function (success, result) {
                    if ($scope.data.couponsGeneration.status) {
                        if (success) {
                            $scope.data.couponsGeneration.status = false;
                            $scope.data.couponsGeneration.progress = 100;

                            // $scope.data.couponsList = $scope.data.couponsList.concat(result.data);
                        }
                        callback(success, result);
                    } else {
                        $scope.data.couponsGeneration.status = false;
                    }
                });
            } else if (iterations > 1) {
                params.count = chunk;
                CouponsService.GenerateCoupons(batch_id, params, handleResult);
            }

        }

        function importCoupons(batch_id, coupons, callback) {
            var total = coupons.length,
                chunk_size = 100,
                iterations = Math.ceil(coupons.length / chunk_size),
                chunk = coupons.splice(0, chunk_size),
                step = 1,
                params = {};

            if (iterations < 1)
                iterations = 1;

            $scope.data.externalCodesImport.status = 'inprocess';
            $scope.data.externalCodesImport.progress = 0;
            $scope.data.externalCodesImport.results = {
                processed: 0,
                skipped: 0,
                unique: 0
            };

            // $scope.data.couponsList = [];

            function handleResult(success, result) {
                if ($scope.data.externalCodesImport.status === 'inprocess') {
                    if (success) {
                        $scope.data.externalCodesImport.progress += 100 / iterations;

                        for (var i in result.operation_result)
                            $scope.data.externalCodesImport.results[i] += result.operation_result[i];

                        ++step;
                        total -= chunk_size;
                        if (step === iterations) {
                            params.count = total;
                            chunk = coupons.splice(0, chunk_size);
                            CouponsService.ImportExternalCoupons(batch_id, chunk, handleResult);
                        } else if (step < iterations) {
                            params.count = chunk_size;
                            chunk = coupons.splice(0, chunk_size);
                            CouponsService.ImportExternalCoupons(batch_id, chunk, handleResult);
                        } else if (step > iterations) {
                            $scope.data.externalCodesImport.status = 'completed';
                            $scope.data.externalCodesImport.progress = 100;
                            callback(success, result);
                        }
                    } else {
                        callback(false, result);
                        $scope.data.externalCodesImport.status = 'failed';
                    }
                }
            }

            if (iterations === 1) {
                params.count = total;
                CouponsService.ImportExternalCoupons(batch_id, chunk, function (success, result) {
                    if ($scope.data.externalCodesImport.status) {
                        if (success) {
                            for (var i in result.operation_result)
                                $scope.data.externalCodesImport.results[i] += result.operation_result[i];

                            $scope.data.externalCodesImport.status = 'completed';
                            $scope.data.externalCodesImport.progress = 100;
                        }
                        callback(success, result);
                    } else {
                        callback(false, result);
                        $scope.data.externalCodesImport.status = 'failed';
                    }
                });
            } else if (iterations > 1) {
                params.count = chunk_size;
                CouponsService.ImportExternalCoupons(batch_id, chunk, handleResult);
            }
        }

        function onChangeLanguage(new_lang) {
            $scope.multiLang.selected(new_lang);
        }

        function initLocaleStrings(batch) {
            $scope.multiLang.initStrings(batch, ['public_title', 'public_description']);
        }

        function initNewCouponBatch() {
            $scope.model.new_batch = {
                loyalty_id: $scope.data.currentLoyalty.id,
                title: '',
                public_title: null,
                public_description: null,
                emission_period_begin: moment().startOf('day').utc().toDate(),
                emission_period_end: moment().add(10, 'year').utc().toDate(),
                emission_quantity_limit: 0,
                emission_quantity_limit_unlimited: true,
                emission_per_customer_limit: 0,
                emission_per_customer_limit_unlimited: true,
                use_unique_coupon_code: 1,
                coupon_expire_type: 'none',
                coupon_expire_value: 1,
                coupon_expire_date: moment().add(1, 'month').utc().toDate(),
                type: 'check-modifier',
                rules: [],
                charge_type: 'regular-bonuses',
                bonuses_currency: $rootScope.ENV.business.currency,
                charge_amount: 0,
                special_account_id: null,
                promotional_bonuses_expire_type: 'date',
                promotional_bonuses_expire_value: 1,
                promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                use_one_external_code: 1,
                external_code: '',
                external_codes_list_import: [],
                external_code_visibility_type: 'on-redeem',
                generate_coupons_on_create: false,
                coupons_to_be_generated_quantity: 1,
                base_batch_code: null,
                share_allowed: 0,
                recommendation_fee_bonuses_currency: $rootScope.ENV.business.currency,
                recommendation_fee_amount: 0,
                recommendation_fee_type: 'none',
                recommendation_fee_promotional_bonuses_expire_type: 'date',
                recommendation_fee_promotional_bonuses_expire_value: 1,
                recommendation_fee_promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                exchange_coupon_redeem_fee_allowed: false,
                exchange_coupon_redeem_fee: 0,
                anonymous_owned_data_access_allowed: 1,
                customers_price_amount_free: true,
                customers_price_amount: 0,
                customers_price_type: 'bonuses',
                customers_price_special_account_id: null,
                customers_price_currency: $rootScope.ENV.business.currency,
                auto_generated_external_codes: 0
            };

            $scope.model.batch = angular.copy($scope.model.new_batch);
        }

        function _doShow() {
            function s() {
                if ($scope.data.currentLoyalty && $rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.use_coupons_and_certificates) {
                        getCouponsBatches(function (success) {
                        });
                        $rootScope.TARIFF_LIMITATION.use_coupons_and_certificates = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.use_coupons_and_certificates = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function _doDetails() {
            $scope.data.currentBatchId = $routeParams.batch_id;

            if ($scope.data.couponBatchesList && $scope.data.couponBatchesList.length > 0)
                $scope.model.batch = itemByIndex($scope.data.couponBatchesList, $scope.data.currentBatchId);

            getCouponsBatch($scope.data.currentBatchId, function (success, response) {
                if (success) {
                    if (!$scope.data.currentLoyalty)
                        $scope.data.currentLoyalty = {id: $scope.model.batch.loyalty_id};

                    $scope.params.filterDates.startDate = {
                        date: moment($scope.model.batch.emission_period_begin).startOf('day').utc().toDate(),
                        time: moment($scope.model.batch.emission_period_begin).startOf('day').utc().toDate()
                    };

                    $scope.params.filterDates.coupon_emission_dt_from = angular.copy($scope.params.filterDates.startDate);
                    $scope.params.filterDates.coupon_taken_by_customer_dt_from = angular.copy($scope.params.filterDates.startDate);
                    $scope.params.filterDates.coupon_redeem_dt_from = angular.copy($scope.params.filterDates.startDate);

                    getCoupons();
                    getAliases();

                    if (response.type === 'external' && $scope.model.batch.use_one_external_code === 0)
                        getExternalCodes(function (success, data) {
                        });
                    // getLoyaltyRules();
                    // getAccountsList();
                }

            });
        }

        function _doCreate() {
            function s() {
                if ($rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.use_coupons_and_certificates) {
                        $rootScope.TARIFF_LIMITATION.use_coupons_and_certificates = false;

                        if (!$scope.model.batch)
                            initNewCouponBatch();

                        getLoyaltyRules();
                        getAccountsList();
                        getCurrenciesList();

                        initLocaleStrings($scope.model.batch);

                        if ($routeParams['p'] === true) {
                            $location.search({p: null});
                            $scope.model.batch.type = 'cross-business';
                            $scope.model.batch.base_batch_code = $routeParams['c'];

                            $scope.model.batch.emission_period_begin = moment($routeParams['pb']).utc().toDate();
                            $scope.model.batch.emission_period_end = moment($routeParams['pe']).utc().toDate();

                            if ($routeParams['img']) {
                                $scope.data.batchImage.new = true;

                                imgToDataUrl($routeParams['img'], function (img) {
                                    $scope.data.batchImage.src = img;
                                });
                            }

                            try {
                                $scope.model.batch.public_title = JSON.parse($routeParams['t']);
                                $scope.model.batch.title = getLocalizeField($scope.model.batch.public_title, $rootScope.LANG);
                                $scope.model.batch.public_description = JSON.parse($routeParams['d']);
                            } catch (e) {

                            }
                        }
                    } else {
                        $location.path('/series');
                        $rootScope.TARIFF_LIMITATION.use_coupons_and_certificates = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function _doEdit() {
            $scope.data.currentBatchId = $routeParams.batch_id;
            block_batch_edit.start();
            getCouponsBatch($scope.data.currentBatchId, function (success, response) {
                getLoyaltyRules();
                getAccountsList();
                getCurrenciesList();

                handleBatchData();

                initLocaleStrings($scope.model.batch);

                $scope.model.batch = dateFieldsFormat($scope.model.batch, 'YYYY-MM-DD');

                block_batch_edit.stop();
            });
        }

        function _doDuplicate() {
            block_batch_edit.start();
            getCouponsBatch($routeParams.batch_id, function (success, response) {
                getLoyaltyRules();
                getAccountsList();
                getCurrenciesList();

                handleBatchData();

                initLocaleStrings($scope.model.batch);

                $scope.model.batch = dateFieldsFormat($scope.model.batch, 'YYYY-MM-DD');

                if ($scope.model.batch.image) {
                    $scope.data.batchImage.new = true;

                    imgToDataUrl($scope.model.batch.image, function (img) {
                        $scope.data.batchImage.src = img;
                    });
                }

                $scope.model.batch.generate_coupons_on_create = false;
                $scope.model.batch.coupons_to_be_generated_quantity = 1;

                block_batch_edit.stop();
            });
        }

        $scope.onCouponsBatchSave = function (form, closeOnSave) {

            function handleRedirect(response) {
                $scope.model.batch.id = response.id;
                if ($scope.model.batch.generate_coupons_on_create && $scope.model.batch.external_codes_list_import.length > 0)
                    importCoupons(response.id, $scope.model.batch.external_codes_list_import, function (success, data) {
                        if (success)
                            generateCoupons(response.id, $scope.model.batch.coupons_to_be_generated_quantity, function (success, data) {
                                if (success && closeOnSave)
                                    $location.path('/series/details/' + response.id);
                                else
                                    $scope.error.message = data.message;
                            });
                        else
                            $scope.error.message = data.message;
                    });
                else if ($scope.model.batch.generate_coupons_on_create)
                    generateCoupons(response.id, $scope.model.batch.coupons_to_be_generated_quantity, function (success, data) {
                        if (success && closeOnSave)
                            $location.path('/series/details/' + response.id);
                        else
                            $scope.error.message = data.message;
                    });
                else if ($scope.model.batch.external_codes_list_import && $scope.model.batch.external_codes_list_import.length > 0)
                    importCoupons(response.id, $scope.model.batch.external_codes_list_import, function (success, data) {
                        if (success && closeOnSave)
                            $location.path('/series/details/' + response.id);
                        else
                            $scope.error.message = data.message;
                    });
                else
                    $location.path('/series/details/' + response.id);
            }

            function handleResult(success, response) {
                if (success) {
                    if ($scope.data.batchImage.new) {
                        var image = $scope.data.batchImage.cropped || $scope.data.batchImage.src;
                        CouponsService.UploadPhoto(response.id, image, function (success, upload_response) {
                            if (success) {
                                response.image = upload_response.image;

                                handleRedirect(response);
                            }
                        });
                    } else {
                        handleRedirect(response);
                    }
                    if ($scope.data.currentLoyalty.id && $rootScope.COUPONS_BATCHES[$scope.data.currentLoyalty.id])
                        updateItemInList($rootScope.COUPONS_BATCHES[$scope.data.currentLoyalty.id].data, response);
                } else {
                    if (response.code === 141)
                        form[response.field].$error.required = true;
                }
                block_batch_edit.stop();
            }

            if (isFormValid(form)) {
                block_batch_edit.start();

                var post_data = angular.copy($scope.model.batch);
                post_data.loyalty_id = $scope.data.currentLoyalty.id;

                post_data = dateFieldsFormat(post_data, 'YYYY-MM-DD[T]HH:mm:ss[Z]', 'YYYY-MM-DD');
                post_data = cleanRequestData(post_data);

                if (post_data.created) delete post_data.created;

                switch ($scope._pageMode) {
                    case 'create':
                    case 'duplicate':
                        CouponsService.CreateBatch(post_data, handleResult);
                        break;
                    case 'edit':
                        CouponsService.ChangeBatch($scope.data.currentBatchId, post_data, handleResult);
                        break;
                    default:

                }
            }
        };

        $scope.onGenerateCoupons = function (batch) {
            $scope.modals.modalGenerateCoupons = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                size: 'md',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        count: undefined
                    };
                    popup.batch = $scope.model.batch;
                    popup.data = $scope.data;
                    popup.type = 'generate_coupons';

                    popup.getPossibleEmittionQuantity = function () {
                        if (popup.batch.emission_quantity_limit == 0)
                            return 10000;
                        if (popup.batch.emission_quantity_limit > 0)
                            return popup.batch.emission_quantity_limit - popup.batch.emitted_coupons_quantity;
                        return 1;
                    };

                    popup.onOkClick = function (form) {
                        if (form && form.$valid) {
                            generateCoupons(batch.id, popup.model.count, function (success, response) {
                                if (success) {

                                    getCouponsBatch($scope.data.currentBatchId, function (success, response) {
                                    });
                                    getCoupons();

                                    if (batch.type === 'external' && batch.auto_generated_external_codes === 1)
                                        getExternalCodes(function (success, data) {
                                        });

                                    $scope.modals.modalGenerateCoupons.close();
                                }
                            });
                        }
                    };

                    popup.onCancelClick = function (exit) {
                        popup.onRequestAbort();
                        $scope.modals.modalGenerateCoupons.close();
                    };

                    popup.onRequestAbort = function () {
                        popup.data.couponsGeneration.status = false;
                        popup.data.couponsGeneration.progress = 0;
                    };
                }
            });
        };

        $scope.onExternalCodesImport = function (src) {
            if (!$scope.modals.modalImportExternalCoupons ||
                ($scope.modals.modalImportExternalCoupons && $scope.modals.modalImportExternalCoupons.closed.$$state.status === 1)) {
                $scope.modals.modalImportExternalCoupons = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    size: 'lg',
                    templateUrl: 'app/templates/modal.coupons.import.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.batch = $scope.model.batch;
                        popup.data = $scope.data;
                        popup.src = src;
                        popup.error = $scope.error;

                        popup.model = {
                            external_codes: $scope.model.batch.external_codes_list_import,
                            manual_external_codes: []
                        };
                        popup.params = {
                            external_codes: {
                                page: 1,
                                count: 40,
                                pagers: [40, 80, 160]
                            }
                        };
                        popup.data.summaryExternalCodes = {
                            total_rows_count: 0
                        };

                        popup.getPages = getTotalPaginatedPages;

                        if (popup.src === 'details')
                            popup.model.external_codes = [];

                        popup.onOkClick = function (exit) {
                            if (popup.src === 'details') {
                                $scope.error.message = null;
                                $scope.data.externalCodesImport.status = null;
                            }

                            $scope.model.batch.external_codes_list_import = popup.model.external_codes;
                            $scope.modals.modalImportExternalCoupons.close();
                        };

                        popup.fileChanged = function (event) {
                            var a = event.srcElement.value.split('.');

                            $timeout(function () {

                                try {
                                    alasql.promise('SELECT * FROM FILE(?,{headers:false})', [event]).then(function (data) {
                                        if (data) {
                                            popup.processImportData(data);
                                        }
                                    });

                                } catch (e) {
                                    console.log(e)
                                }
                            }, 200, true);
                        };

                        popup.onFileSelect = function () {
                            var file = angular.element(document.getElementById('dataFileInput'));
                            file.val(null);
                        };

                        popup.processImportData = function (data) {
                            var external_codes = [];

                            function onlyUnique(value, index, array) {
                                return array.indexOf(value) === index;
                            }

                            $timeout(function () {
                                for (var i in data)
                                    Object.keys(data[i]).forEach(function (k) {
                                        external_codes = external_codes.concat(parseCodes(data[i][k].toString()));
                                    });

                                popup.model.external_codes = external_codes.filter(onlyUnique);
                                popup.data.summaryExternalCodes.total_rows_count = popup.model.external_codes.length;
                                // popup.params.external_codes.page = popup.getPages(popup.data.summaryExternalCodes.total_rows_count/popup.params.external_codes.count);
                            }, 100);

                        };

                        popup.onImportClick = function () {
                            importCoupons(popup.batch.id, popup.model.external_codes, function (success, data) {
                                if (success)
                                    getExternalCodes(function (success) {
                                    });
                                else
                                    popup.error.message = data.message;
                            });
                        };

                        popup.onImportAgainClick = function () {
                            popup.data.externalCodesImport.status = null;
                            popup.params.external_codes = [];
                        };

                        popup.pageChange = function () {

                        };

                        popup.onCountChange = function (count) {
                            popup.params.external_codes.page = 1;
                            popup.params.external_codes.count = count;
                        };

                        popup.onRemoveCode = function (c) {
                            if (popup.model.external_codes.indexOf(c) !== -1)
                                popup.model.external_codes.splice(popup.model.external_codes.indexOf(c), 1);
                        };

                        function parseCodes(values) {
                            return (values || '').split(
                                new RegExp([',', ';', '\t', '\n'].join('|'), 'g')
                            ).map(function (value) {
                                return value.trim();
                            }).filter(function (value) {
                                return value.length > 0;
                            });
                        }

                        popup.onManualyCodeAdd = function () {
                            var list = popup.model.manual_external_codes;

                            if (list.length === 1) {
                                list = parseCodes(list[0].code).map(function (code) {
                                    return {code: code};
                                });
                            }

                            if (!popup.params.external_codes)
                                popup.params.external_codes = [];

                            for (var i in list)
                                if (popup.model.external_codes.indexOf(list[i].code) === -1) {
                                    popup.model.external_codes.unshift(list[i].code);
                                }

                            popup.params.external_codes.page = 1;
                            popup.model.manual_external_codes = [];
                            popup.data.summaryExternalCodes.total_rows_count = popup.model.external_codes.length;
                        };

                        popup.codesTagHandler = function (code) {
                            return {code: code};
                        };

                        popup.pasteTagHandler = function (values) {
                            var values_list = parseCodes(values);

                            if (values_list && values_list.length > 0) {
                                values_list = values_list.filter(function (elem, index, self) {
                                    return index == self.indexOf(elem);
                                });

                                for (var i in values_list) {
                                    if (values_list[i]) {
                                        this.ngModel.$modelValue.push({code: values_list[i]});
                                    }
                                }
                            }

                            popup.onManualyCodeAdd();
                        };

                    }
                });
            }
        };

        $scope.getMaxCouponsQuantity = function () {
            if ($scope.model.batch.type === 'external' && $scope.model.batch.auto_generated_external_codes === 0 &&
                $scope.model.batch.use_one_external_code === 0)
                return $scope.model.batch.emission_quantity_limit == 0
                    ? ($scope.model.batch.external_codes_list_import.length > 0
                            ? $scope.model.batch.external_codes_list_import.length
                            : 0
                    )
                    : ($scope.model.batch.external_codes_list_import.length > $scope.model.batch.emission_quantity_limit
                            ? $scope.model.batch.emission_quantity_limit
                            : $scope.model.batch.external_codes_list_import.length
                    );
            else
                return $scope.model.batch.emission_quantity_limit == 0 ? 10000 : $scope.model.batch.emission_quantity_limit;
        };

        $scope.onGoToDetails = function () {
            $location.path('/series/details/' + $scope.model.batch.id);
        };

        $scope.onBatchDisable = function (batch) {
            $scope.modals.modalBatchDisable = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {};
                    popup.type = 'batch_disable';

                    popup.onOkClick = function (exit) {
                        CouponsService.CancelBatch(batch.id, popup.model, function (success, response) {
                            if (success) {
                                $scope.model.batch = response;
                                if (popup.model.cancel_coupons)
                                    getCoupons();

                                // updateItemInList($rootScope.COUPONS_BATCHES[response.loyalty_id].data, response);
                                $scope.modals.modalBatchDisable.close();
                            }
                        });
                    };

                    popup.onCancelClick = function (exit) {
                        $scope.modals.modalBatchDisable.close();
                    };
                }
            });
        };

        $scope.onBatchEnable = function (batch) {
            var post_data = {
                active: 1
            };

            CouponsService.ChangeBatch(batch.id, post_data, function (success, response) {
                if (success) {
                    $scope.model.batch = response;
                    if ($rootScope.COUPONS_BATCHES[response.loyalty_id])
                        updateItemInList($rootScope.COUPONS_BATCHES[response.loyalty_id].data, response);
                }
            });
        };

        $scope.onBatchCouponsDisable = function (batch) {
            $scope.modals.modalBatchCouponsDisable = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {};
                    popup.type = 'coupons_disable';

                    popup.onOkClick = function (exit) {
                        CouponsService.CancelBatchCoupons(batch.id, function (success, response) {
                            if (success) {
                                // $scope.model.batch = response;
                                getCoupons();
                                $scope.modals.modalBatchCouponsDisable.close();
                            }
                        });
                    };

                    popup.onCancelClick = function (exit) {
                        $scope.modals.modalBatchCouponsDisable.close();
                    };
                }
            });
        };

        $scope.onShareCoupon = function (coupon) {
            getCoupon(coupon.code, function (success, response) {
                CouponsService.GerCouponLinks(response.batch.id, function (successSettings, data) {
                    $scope.modalCouponShare = $uibModal.open({
                        animation: true,
                        keyboard: true,
                        size: 'md',
                        backdrop: 'static',
                        templateUrl: 'app/templates/modal.item.share.html',
                        controllerAs: 'popup',
                        controller: function ($uibModalInstance) {
                            var popup = this;

                            popup.coupon = coupon;
                            for (var i in response)
                                popup.coupon[i] = response[i];

                            popup.model = {
                                share: {
                                    text: popup.coupon.batch.public_title + ' ',
                                    tags: 'discount, sale, coupon, gift, ' + appConfig.platformParams.platform_name[$rootScope.LANG] + ', LoyaltyPays',
                                    image: popup.coupon.batch.image ? popup.coupon.batch.image : 'assets/img/dummy_coupon_batch.png',
                                    link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] + '/coupon/show/' + coupon.code + '?lang=' +
                                        $rootScope.LANG
                                }
                            };

                            if (successSettings && data[0] && data[0].coupon_path_share) {
                                var link = data[0].coupon_path_share;
                                if (link) {
                                    link = link.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                                    link = link.replaceAll('{{coupon}}', coupon.code);
                                    link = link.replaceAll('{{lang}}', $rootScope.LANG);
                                    popup.model.share.link = link;
                                }
                            }

                            popup.model.share.title = popup.coupon.batch.public_title;
                            popup.model.share.description = popup.coupon.batch.public_description;

                            popup.onCopyLink = function () {
                                $scope.modalCouponShare.close();
                            };

                            popup.onCancelClick = function () {
                                $scope.modalCouponShare.close();
                            };
                        }
                    });
                });
            });
        };

        $scope.onPrintCoupon = function (coupon, type) {
            var id = type === 'coupon' ? coupon.id : coupon.code;
            var coupon_block = blockUI.instances.get('coupon_block');
            coupon_block.start();
            $scope.modalCouponPrint = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'lg',
                backdrop: 'static',
                templateUrl: 'app/templates/modal.item.print.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type = 'coupon';

                    var params = {
                        lang: $rootScope.LANG,
                        qr_code_link: coupon.code,
                        custom_open_link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] + '/coupon/show/' + coupon.code + '?lang=' +
                            $rootScope.LANG
                    }

                    if (coupon.links && coupon.links[0] && coupon.links[0].coupon_path_share) {
                        var link = coupon.links[0].coupon_path_qr;
                        if (link) {
                            link = link.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                            link = link.replaceAll('{{coupon}}', coupon.code);
                            link = link.replaceAll('{{lang}}', $rootScope.LANG);
                            params.qr_code_link = link;
                        }

                        var openLink = coupon.links[0].coupon_path_share;
                        if (openLink) {
                            openLink = openLink.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                            openLink = openLink.replaceAll('{{coupon}}', coupon.code);
                            openLink = openLink.replaceAll('{{lang}}', $rootScope.LANG);
                            params.custom_open_link = openLink;
                        }
                    }

                    ReceiptService.getCouponView(id, params, function (success, viewData) {
                        popup.couponView = $sce.trustAsHtml(viewData.data);
                        coupon_block.stop();
                    })

                    popup.onItemPrint = function () {
                        coupon_block.start();
                        ReceiptService.getCouponPdf(id, params, function (successPdf, res) {
                            if (!successPdf) {
                                NotifyService.Error('Can not print the receipt', true);
                                coupon_block.stop();
                                return;
                            }
                            var binary = atob(res.data.data.replace(/\s/g, ''));
                            var len = binary.length;
                            var buffer = new ArrayBuffer(len);
                            var view = new Uint8Array(buffer);
                            for (var i = 0; i < len; i++) {
                                view[i] = binary.charCodeAt(i);
                            }
                            var blob = new Blob([view], {type: "application/pdf"});
                            saveAs(blob, `coupon-${coupon.id}.pdf`);
                            coupon_block.stop();
                        })
                    };

                    popup.onCancelClick = function () {
                        $scope.modalCouponPrint.close();
                    };
                }
            });
        };

        $scope.onCouponDisable = function (coupon) {
            CouponsService.CancelCoupon(coupon.id, function (success, response) {
                if (success)
                    updateItemInList($scope.data.couponsList, response);
            });
        };

        $scope.onBaseBatchCodePaste = function (e) {
            var t = e.originalEvent.clipboardData.getData('text/plain').replace(/\D/g, '');
            $timeout(function () {
                $scope.model.batch.base_batch_code = t;
            }, 300);
        };

        $scope.onCancelEdit = function () {
            $location.path('/series');
        };

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting_asc': $scope.params.coupons.sort_field == row.value && $scope.params.coupons.sort_order == 'asc',
                'sorting_desc': $scope.params.coupons.sort_field == row.value && $scope.params.coupons.sort_order == 'desc',
                'sorting': !row.not_sortable
            };
        };

        $scope.onFilterCoupons = function (row) {
            getCoupons();
        };

        $scope.onSortOrderChange = function (row) {
            if (!!row.not_sortable) {
                return;
            }
            var field = row.value;

            if ($scope.params.coupons.sort_field == field)
                $scope.params.coupons.sort_order = $scope.params.coupons.sort_order == 'asc' ? 'desc' : 'asc';

            $scope.params.coupons.sort_field = field;
            getCoupons();

        };

        $scope.onPageChange = function (entity) {
            switch (entity) {
                case 'batches':
                    getCouponsBatches(function (success) {
                    });
                    break;
                case 'coupons':
                    getCoupons();
                    break;
                case 'aliases':
                    getAliases();
                    break;
                case 'external_codes':
                    getExternalCodes(function (success) {
                    });
                    break;
            }
        };

        $scope.onChangeShowOnlyActive = function () {
            getCouponsBatches(function (success) {
            });
        };

        $scope.onCountChange = function (entity, count) {
            switch (entity) {
                case 'batches':
                    $scope.params.batches.page = 1;
                    $scope.params.batches.count = count;

                    getCouponsBatches(function (success) {
                    });
                    break;
                case 'coupons':
                    $scope.params.coupons.page = 1;
                    $scope.params.coupons.count = count;

                    getCoupons();
                    break;
                case 'aliases':
                    $scope.params.aliases.page = 1;
                    $scope.params.aliases.count = count;

                    getAliases();
                    break;
                case 'external_codes':
                    $scope.params.external_codes.page = 1;
                    $scope.params.external_codes.count = count;

                    getExternalCodes(function (success) {
                    });
                    break;
            }
        };

        /**
         * Выбрать все чекбоксы в таблице
         */
        $scope.onSelectAllCoupons = function () {
            for (var i in $scope.data.couponsList)
                $scope.selectedUsers[$scope.data.couponsList[i].id] = !$scope.state.selectedAll;
        };

        $scope.openSendMessagePopup = function () {
            SendMessageService.popupSendMessage($scope, $scope.model.batch);
        };

        $scope.changeDescFieldMode = function () {
            $scope.publicDescriptionEditorField = !$scope.publicDescriptionEditorField;
        };

        $scope.stripFormat = function ($html) {
            return $filter('htmlToPlaintext')($html);
        };

        $scope.openChangePathSettings = function (batch_id) {
            $scope.modalCouponShare = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                backdrop: 'static',
                templateUrl: 'app/pages/series/modals/modal.change-paths.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this,
                        batch_coupon_links = blockUI.instances.get('batch_coupon_links');

                    batch_coupon_links.start();

                    popup.defaultData = {
                        coupon_path_qr: '{{coupon}}',
                        coupon_path_qr_errors: [],
                        coupon_path_share: 'https://{{platform}}/coupon/show/{{coupon}}?lang={{lang}}',
                        coupon_path_share_errors: [],
                    }

                    CouponsService.GerCouponLinks(batch_id, function (success, data) {
                        if (success && data.length > 0) {
                            popup.data = {
                                coupon_path_qr: data[0].coupon_path_qr || '{{coupon}}',
                                coupon_path_qr_errors: [],
                                coupon_path_share: data[0].coupon_path_share || 'https://{{platform}}/coupon/show/{{coupon}}?lang={{lang}}',
                                coupon_path_share_errors: [],
                            }
                            batch_coupon_links.stop();
                            return
                        }
                        popup.data = angular.copy(popup.defaultData);
                        batch_coupon_links.stop();
                    })

                    popup.required_values = [
                        {
                            title: 'coupon',
                            value: '{{coupon}}'
                        }
                    ]
                    popup.available_values = [
                        {
                            title: 'platform',
                            value: '{{platform}}'
                        },
                        {
                            title: 'Language',
                            value: '{{lang}}'
                        }
                    ]

                    popup.addVariableToMessage = function (form, field, available_value) {
                        setVariableValue(field, available_value);
                        field.$setDirty();
                        popup.checkInputValue(form, field)
                    };

                    popup.setDefault = function (field) {
                        var inputEl = angular.element(document.querySelector('#' + field.$name));

                        if (field.$name === 'coupon_path_qr') {
                            popup.data.coupon_path_qr = '{{coupon}}'
                            field.$$setModelValue(popup.coupon_path_qr);
                            field.$setDirty();
                            field.$invalid = false;
                            popup.data[`${field.$name}_errors`] = [];
                            inputEl.focus();
                            return;
                        }

                        if (field.$name === 'coupon_path_share') {
                            popup.data.coupon_path_share = 'https://{{platform}}/coupon/show/{{coupon}}?lang={{lang}}'
                            field.$$setModelValue(popup.data.coupon_path_share);
                            field.$setDirty();
                            field.$invalid = false;
                            popup.data[`${field.$name}_errors`] = [];
                            inputEl.focus();
                            return;
                        }
                    }

                    popup.checkInputValue = function (form, field) {
                        const err = []
                        popup.required_values.forEach(function (el) {
                            if (!popup.data[field.$name]) {
                                err.push(`${el.title} required`);
                                return
                            }

                            if (popup.data[field.$name] && !popup.data[field.$name].includes(el.value)) {
                                err.push(`${el.title} required`)
                            }
                        })

                        if (err && err.length > 0) {
                            field.$setDirty();
                            field.$invalid = true;
                        }

                        popup.data[`${field.$name}_errors`] = err
                    }

                    function setVariableValue(field, available_value) {
                        var message = field.$viewValue || '';
                        var inputEl = angular.element(document.querySelector('#' + field.$name));

                        if (inputEl.prop('selectionStart') || inputEl.prop('selectionStart') == '0') {

                            // Для браузеров типа Firefox и других Webkit-ов
                            var startPos = inputEl.prop('selectionStart');
                            var endPos = inputEl.prop('selectionEnd');
                            var scrollTop = inputEl.prop('scrollTop');
                            message = message.substring(0, startPos) + available_value + message.substring(endPos, message.length);

                            inputEl.focus();
                            inputEl.selectionStart = startPos + available_value.length;
                            inputEl.selectionEnd = startPos + available_value.length;
                            inputEl.scrollTop = scrollTop;
                        } else {
                            message += available_value;
                            inputEl.focus();
                        }
                        popup.data[field.$name] = message
                        field.$$setModelValue(message);
                    }

                    popup.isNotRequiredValues = function (availableValue, requiredValueArr) {
                        return requiredValueArr.indexOf(availableValue) === -1;
                    };

                    popup.saveChanges = function (form) {
                        if (popup.data.coupon_path_qr_errors.length > 0 || popup.data.coupon_path_share_errors.length > 0 || form.$invalid) {
                            return
                        }
                        batch_coupon_links.start();
                        var post_data = [
                            {
                                coupon_path_qr: popup.data.coupon_path_qr,
                                coupon_path_share: popup.data.coupon_path_share,
                                type: "base"
                            }
                        ]
                        CouponsService.ChangeCouponLinks(batch_id, post_data, function (success, response) {
                            batch_coupon_links.stop();
                            if (!success) {
                                NotifyService.Error('', false);
                                return;
                            }
                            NotifyService.Success('', false);
                            $scope.modalCouponShare.close();
                        })
                    }

                    popup.onCancelClick = function () {
                        $scope.modalCouponShare.close();
                    };
                }
            });

        };


        $scope.onGetAliases = getAliases;

        $scope.onChangeAliasesPager = function () {
            console.log('TablePager onPagerChange', $scope.params.aliases);
            getAliases();
        };

        $scope.getTableHeaderAliasesClass = function (row) {
            return {
                'sorting_asc': $scope.params.aliases.sort_field == row.value && $scope.params.aliases.sort_order == 'asc',
                'sorting_desc': $scope.params.aliases.sort_field == row.value && $scope.params.aliases.sort_order == 'desc',
                'sorting': !row.not_sortable
            };
        };

        $scope.onSortOrderAliasesChange = function (row) {
            if (!!row.not_sortable) {
                return;
            }
            var field = row.value;

            if ($scope.params.aliases.sort_field == field)
                $scope.params.aliases.sort_order = $scope.params.aliases.sort_order == 'asc' ? 'desc' : 'asc';

            $scope.params.aliases.sort_field = field;
            getAliases();

        };

        function getAliases() {

            block_batch_aliases_list.start();

            var params = angular.copy($scope.params.aliases);

            params.batch_id = $scope.model.batch.id;

            params.created_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            }).toISOString();
            delete params.time_from;
            delete params.date_from;

            params.created_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            }).toISOString();

            delete params.time_to
            delete params.date_to;

            CouponsService.findCouponAliases(params, function (success, response) {
                if (success) {
                    $scope.data.aliases = response;
                }
                block_batch_aliases_list.stop();
            })
        }

        $scope.toggleAliasStatus = function (alias) {

            block_batch_aliases_list.start();

            var post_data = {
                active: alias.active == 1 ? 0 : 1,
            }

            CouponsService.ChangeCouponAlias(alias.id, post_data, function (success, response) {

                block_batch_aliases_list.stop();

                if (!success) {
                    NotifyService.Error('', false);
                    return;
                }

                getAliases();
            })
        }


        $scope.onEditAlias = function (alias_id) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/series/modals/edit-alias.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this,
                        block_alias_edit = blockUI.instances.get('alias_edit');

                    block_alias_edit.start();

                    CouponsService.GetCouponAliasById(alias_id, function (success, response) {

                        popup.model = {
                            active: response.active,
                            expire_type: response.expire_type,
                            expire_value: response.expire_value || 0,
                            expire_date: response.expire_date,
                            emission_quantity_limit: response.emission_quantity_limit,
                            emission_quantity_limit_unlimited: !response.emission_quantity_limit,
                            emission_per_customer_limit: response.emission_per_customer_limit,
                            emission_per_customer_limit_unlimited: !response.emission_per_customer_limit
                        }
                        block_alias_edit.stop();
                    })


                    popup.edit = function (form) {
                        if (!form || !form.$valid) {
                            return;
                        }

                        block_alias_edit.start();

                        var post_data = angular.copy(popup.model);

                        CouponsService.ChangeCouponAlias(alias_id, post_data, function (success, response) {

                            block_alias_edit.stop();

                            if (!success) {
                                NotifyService.Error('', false);
                                return;
                            }

                            $uibModalInstance.close();
                            getAliases();
                        })

                    }

                    popup.cancel = function () {
                        $uibModalInstance.close();
                    }
                }

            })
        }

        $scope.onGenerateAlias = function (batch) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/series/modals/add-alias.modal.html',
                controllerAs: 'popup',
                backdrop: 'static',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.couponsGeneration = {
                        status: false,
                        progress: 0
                    }

                    popup.model = {
                        count: 1,
                        alias: {
                            active: 1,
                            expire_type: 'none',
                            expire_value: 1,
                            expire_date: moment().add(1, 'month').utc().toDate(),
                            emission_quantity_limit: 0,
                            emission_quantity_limit_unlimited: true,
                            emission_per_customer_limit: 0,
                            emission_per_customer_limit_unlimited: true
                        }
                    }

                    popup.more_settings = false;

                    popup.getPossibleEmissionQuantity = function () {
                        if (!batch.emission_quantity_limit) {
                            return 10000;
                        }
                        if (batch.emission_quantity_limit > 0) {
                            return popup.batch.emission_quantity_limit - batch.emitted_coupons_quantity;
                        }
                        return 1;
                    };

                    popup.generate = function (form) {
                        if (!form || !form.$valid) {
                            return;
                        }

                        var chunk = 50,
                            total = popup.model.count,
                            iterations = Math.ceil(popup.model.count / chunk),
                            step = 1

                        if (iterations < 1)
                            iterations = 1;

                        popup.couponsGeneration.status = true;
                        popup.couponsGeneration.progress = 0;

                        var post_data = {
                            count: popup.model.count
                        };

                        if (popup.more_settings) {
                            post_data = popup.model;
                            if (post_data.aliases) {
                                delete post_data.aliases.emission_quantity_limit_unlimited;
                                delete post_data.aliases.emission_per_customer_limit_unlimited;

                                if (post_data.aliases.coupon_expire_type == 'none') {
                                    delete post_data.aliases.coupon_expire_value;
                                    delete post_data.aliases.coupon_expire_date;
                                }
                            }
                        }

                        function handleGenerationAliases(success, result) {
                            if (popup.couponsGeneration.status) {
                                if (success) {
                                    popup.couponsGeneration.progress += 100 / iterations;
                                    ++step;
                                    total -= chunk;

                                    if (step == iterations) {
                                        post_data.count = total;
                                        CouponsService.AddCouponAlias(batch.id, post_data, handleGenerationAliases);
                                    } else if (step < iterations) {
                                        post_data.count = chunk;
                                        CouponsService.AddCouponAlias(batch.id, post_data, handleGenerationAliases);
                                    } else if (step > iterations) {
                                        popup.couponsGeneration.progress = 100;
                                        setTimeout(function () {
                                            popup.couponsGeneration.status = false;
                                            $uibModalInstance.close();
                                            getAliases();
                                        }, 1200)
                                    }
                                }
                            } else {
                                popup.couponsGeneration.status = false;
                            }
                        }

                        if (iterations == 1) {
                            post_data.count = total;
                            CouponsService.AddCouponAlias(batch.id, post_data, function (success, result) {
                                if (popup.couponsGeneration.status) {
                                    if (success) {
                                        popup.couponsGeneration.progress = 100;
                                        setTimeout(function () {
                                            popup.couponsGeneration.status = false;
                                            $uibModalInstance.close();
                                            getAliases();
                                        }, 1200)
                                    }
                                } else {
                                    popup.couponsGeneration.status = false;
                                }
                            });
                        } else if (iterations > 1) {
                            post_data.count = chunk;
                            CouponsService.AddCouponAlias(batch.id, post_data, handleGenerationAliases);
                        }
                    }

                    popup.cancel = function () {
                        popup.couponsGeneration.status = false;
                        $uibModalInstance.close();
                    }
                }
            });
        };

        $scope.onAliasesExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });

            $scope.data.isFilePreparing = true;

            var params = angular.copy({
                batch_id: $scope.model.batch.id,
            });
            params = Object.assign(params, $scope.params.aliases);

            params.created_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            }).toISOString();
            delete params.time_from;
            delete params.date_from;

            params.created_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            }).toISOString();
            delete params.time_to
            delete params.date_to;

            var tl = [];

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_series-aliases_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                var export_struct = [];

                for (var i in $scope.table_aliases_cols) {
                    for (var k in $scope.table_aliases_cols[i].data) {
                        var text = $scope.table_aliases_cols[i].data[k].text,
                            value = $scope.table_aliases_cols[i].data[k].value;
                        export_struct.push({
                            text: $filter('translate')(text) || text,
                            value: value
                        });
                    }
                }

                var export_data = [];
                for (var i in tl) {
                    var el = {};
                    for (var k in export_struct) {
                        var a, b;
                        a = export_struct[k].text;

                        switch (export_struct[k].value) {
                            case 'code':
                                var code = '';
                                if (tl[i]['code']) {
                                    code = tl[i]['code'];
                                }
                                b = code ? $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' + $filter('limitTo')(code, 4, 8) : '';
                                break;

                            case 'created':
                                b = $filter('date')(tl[i]['created'], 'medium', '+0');
                                break;

                            case 'active' :
                                b = $filter('translate')(tl[i]['status'] == 0 ? 'TEXT_FEEDBACK_SOURCE_DISABLED' : 'Feedback source is active') || '';
                                break;

                            case 'batch_code' :
                                var code = '';
                                if (tl[i]['batch']['code']) {
                                    code = tl[i]['batch']['code'];
                                }
                                b = code ? $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' + $filter('limitTo')(code, 4, 8) : '';

                                break;

                            case 'batch_title' :
                                b = tl[i]['batch']['title'];
                                break;

                            default:
                                b = (tl[i][export_struct[k].value] === null) ? '' : tl[i][export_struct[k].value];
                        }
                        el[a] = b || '';
                    }

                    export_data.push(el);
                }

                $scope.$evalAsync(function ($scope) {
                    $scope.data.isFilePreparing = false;
                });

                switch (format) {
                    case 'XLSX':
                        alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'XLS':
                        alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                        break;
                    case 'CSV':
                        alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                        break;
                }
                return void (0);
            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;

            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.data.aliases.summary.total_rows_count, partCount);

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {
                    getAliases(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;
                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.data.aliases.summary.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                tl = result.data;

                generateFile();
            }

            function getAliases(params) {
                return new Promise(function (resolve) {
                    CouponsService.findCouponAliases(params, function (success, response) {
                        resolve(response);
                    });
                });
            }

            exportRequest();
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                var saved_loyalty;

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id)
                    saved_loyalty = itemByIndex($scope.data.loyaltiesList, $rootScope.ENV.filters.global_filter.loyalty_id);

                if (saved_loyalty && saved_loyalty.active === 1) {
                    $scope.data.currentLoyalty = saved_loyalty;
                } else {
                    $scope.data.currentLoyalty = getFirstActive($scope.data.loyaltiesList);
                }
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue) {
                switch ($scope._pageMode) {
                    case 'show':
                        _doShow();

                        $rootScope.ENV.filters.batches_list = {
                            loyalty_id: newValue.id
                        };
                        $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                        $rootScope.storeENV();
                        break;
                    case 'create':
                        _doCreate();
                        break;
                    case 'duplicate':
                        _doDuplicate();
                        break;
                    case 'edit':
                        _doEdit();
                        break;
                    default:

                }

            }
        }, true);
    }
})();
